var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _linearGradient2, _path12, _linearGradient3, _path13, _linearGradient4, _path14, _linearGradient5, _path15, _linearGradient6, _path16, _linearGradient7, _path17, _linearGradient8, _path18, _linearGradient9, _path19, _linearGradient10, _path20, _path21, _linearGradient11, _path22, _linearGradient12, _path23, _linearGradient13, _path24, _linearGradient14, _path25, _linearGradient15, _path26, _linearGradient16, _path27, _path28, _path29, _path30, _linearGradient17, _path31, _linearGradient18, _path32, _path33, _linearGradient19, _path34, _linearGradient20, _path35, _path36, _linearGradient21, _path37, _linearGradient22, _path38, _linearGradient23, _path39, _linearGradient24, _path40, _linearGradient25, _path41, _linearGradient26, _path42, _linearGradient27, _path43, _linearGradient28, _path44, _linearGradient29, _path45, _linearGradient30, _path46, _linearGradient31, _path47, _linearGradient32, _path48, _linearGradient33, _path49, _linearGradient34, _path50, _path51, _linearGradient35, _path52, _linearGradient36, _path53, _linearGradient37, _path54, _linearGradient38, _path55, _radialGradient, _path56, _radialGradient2, _path57, _linearGradient39, _path58, _linearGradient40, _path59, _linearGradient41, _path60, _linearGradient42, _path61, _linearGradient43, _path62, _linearGradient44, _path63, _linearGradient45, _path64, _linearGradient46, _path65, _linearGradient47, _path66, _path67;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcodeOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 63.947,
    y1: 114.165,
    x2: 63.947,
    y2: 13.784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1578e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c3f2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 13.8h56.5c12.1 0 21.9 9.8 21.9 21.9v56.5c0 12.1-9.8 21.9-21.9 21.9H35.7c-12.1 0-21.9-9.8-21.9-21.9V35.7c0-12.1 9.8-21.9 21.9-21.9z",
    fill: "url(#xcode-original-a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.5 19.2H37.4c-10.1 0-18.3 8.2-18.3 18.3v53.1c0 10.1 8.2 18.3 18.3 18.3h53.1c10.1 0 18.3-8.2 18.3-18.3V37.4c0-10.1-8.2-18.2-18.3-18.2zm16.8 71.6c0 9.2-7.4 16.6-16.6 16.6H37.2c-9.1 0-16.6-7.4-16.6-16.6V37.2c0-9.2 7.4-16.6 16.6-16.6h53.6c9.1 0 16.6 7.4 16.6 16.6v53.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 22.8c-22.6 0-41 18.4-41 41s18.4 41 41 41c22.7 0 41-18.4 41-41s-18.4-41-41-41zm0 81.4c-22.3 0-40.4-18.1-40.4-40.4s18.1-40.4 40.4-40.4c22.3 0 40.4 18.1 40.4 40.4s-18.1 40.4-40.4 40.4z",
    fill: "#69c5f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 31.2c-18.1 0-32.7 14.6-32.7 32.7S46 96.5 64.1 96.5s32.7-14.6 32.7-32.7-14.7-32.6-32.7-32.6zm0 64.6c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.4 32-32 32z",
    fill: "#68c5f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.8 71.3h62.4c2.6 0 4.6 2.1 4.6 4.6 0 2.6-2.1 4.6-4.6 4.6H32.8c-2.6 0-4.6-2.1-4.6-4.6-.1-2.5 2-4.6 4.6-4.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6 72.2h62.6c2 0 3.7 1.6 3.7 3.7v.1c0 2-1.6 3.7-3.7 3.7H32.6c-2 0-3.7-1.6-3.7-3.7v-.2c.1-2 1.7-3.6 3.7-3.6z",
    fill: "#0a93e9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 79.3h65.7l.5-.3H30.6l.5.3z",
    fill: "#1694ea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 78.1h68.6l.2-.3h-69l.2.3z",
    fill: "#319dec"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76.2h69.9v-.4H29v.4z",
    fill: "#65b1ee"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7 73.7h68.6l.1.2.1.2h-69l.1-.2.1-.2z",
    fill: "#8ec6f3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 72.5h65.6l.3.1.3.2H30.6l.3-.2.3-.1z",
    fill: "#95caf3"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 94.037,
    y1: 79.666,
    x2: 94.037,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 72.2h-.5s1.7 1.2 1.7 3.9c0 2.5-1.7 3.6-1.7 3.6h.5s1.7-.8 1.7-3.6c0-3-1.7-3.9-1.7-3.9z",
    fill: "url(#xcode-original-b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-c",
    gradientUnits: "userSpaceOnUse",
    x1: 89.042,
    y1: 79.666,
    x2: 89.042,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 72.2h-.5s1.5 1.4 1.5 3.9c0 2.2-1.5 3.6-1.5 3.6h.5s1.5-1.1 1.5-3.6c-.1-2.7-1.5-3.9-1.5-3.9z",
    fill: "url(#xcode-original-c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-d",
    gradientUnits: "userSpaceOnUse",
    x1: 63.947,
    y1: 79.666,
    x2: 63.947,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7 72.2h.5v7.5h-.5v-7.5z",
    fill: "url(#xcode-original-d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-e",
    gradientUnits: "userSpaceOnUse",
    x1: 58.952,
    y1: 79.666,
    x2: 58.952,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8 72.2h.5s-.2 1.9-.2 3.9c0 1.8.2 3.6.2 3.6h-.5s-.2-1.8-.2-3.6c0-2 .2-3.9.2-3.9z",
    fill: "url(#xcode-original-e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-f",
    gradientUnits: "userSpaceOnUse",
    x1: 53.958,
    y1: 79.666,
    x2: 53.958,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72.2h.5s-.5 1.9-.5 3.9c0 1.8.5 3.6.5 3.6H54s-.5-1.8-.5-3.6c0-2 .5-3.9.5-3.9z",
    fill: "url(#xcode-original-f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-g",
    gradientUnits: "userSpaceOnUse",
    x1: 48.963,
    y1: 79.666,
    x2: 48.963,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1 72.2h.5s-.7 1.9-.7 3.9c0 1.8.7 3.6.7 3.6h-.5s-.7-1.8-.7-3.6c0-2 .7-3.9.7-3.9z",
    fill: "url(#xcode-original-g)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-h",
    gradientUnits: "userSpaceOnUse",
    x1: 43.968,
    y1: 79.666,
    x2: 43.968,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 72.2h.5s-1 1.6-1 3.9c0 2 1 3.6 1 3.6h-.5s-1-1.6-1-3.6c0-2.3 1-3.9 1-3.9z",
    fill: "url(#xcode-original-h)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-i",
    gradientUnits: "userSpaceOnUse",
    x1: 38.852,
    y1: 79.666,
    x2: 38.852,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 72.2h.5s-1.5 1.4-1.5 3.9c0 2.2 1.5 3.6 1.5 3.6h-.5s-1.5-1.1-1.5-3.6c.1-2.7 1.5-3.9 1.5-3.9z",
    fill: "url(#xcode-original-i)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-j",
    gradientUnits: "userSpaceOnUse",
    x1: 33.857,
    y1: 79.666,
    x2: 33.857,
    y2: 72.184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1492e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbedfb"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 72.2h.5s-1.7 1.2-1.7 3.9c0 2.5 1.7 3.6 1.7 3.6h-.5s-1.7-.8-1.7-3.6c0-3 1.7-3.9 1.7-3.9z",
    fill: "url(#xcode-original-j)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M62 34.1l31.2 54c1.3 2.2.5 5-1.7 6.3-2.2 1.3-5 .5-6.3-1.7L54 38.7c-1.3-2.2-.5-5 1.7-6.3 2.2-1.3 5-.5 6.3 1.7z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-k",
    gradientUnits: "userSpaceOnUse",
    x1: 73.58,
    y1: 94.25,
    x2: 73.58,
    y2: 32.642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1285e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b5ef"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2 34.5l31.3 54.2c1 1.7.4 4-1.3 5l-.2.1c-1.7 1-4 .4-5-1.3L54.7 38.2c-1-1.7-.4-4 1.3-5l.1-.1c1.8-1 4.1-.4 5.1 1.4z",
    fill: "url(#xcode-original-k)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-l",
    gradientUnits: "userSpaceOnUse",
    x1: 87.464,
    y1: 93.978,
    x2: 54.081,
    y2: 36.156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b90e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b6ef"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 36.7L87 93.6l.2.1.2.1.2.1-33.4-57.8v.6z",
    fill: "url(#xcode-original-l)"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-m",
    gradientUnits: "userSpaceOnUse",
    x1: 89.073,
    y1: 94.327,
    x2: 54.583,
    y2: 34.589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3795ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49c4f2"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 34.8l34.3 59.4h.4L54.7 34.5l-.1.2-.1.1z",
    fill: "url(#xcode-original-m)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-n",
    gradientUnits: "userSpaceOnUse",
    x1: 91.026,
    y1: 93.735,
    x2: 56.072,
    y2: 33.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3696ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90d9f6"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9 33.3l35 60.5.3-.2-35-60.5-.3.2z",
    fill: "url(#xcode-original-n)"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-o",
    gradientUnits: "userSpaceOnUse",
    x1: 92.582,
    y1: 92.332,
    x2: 58.065,
    y2: 32.547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3097ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5e5f9"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4 32.7L92.6 92l-.1.2-.1.2-34.5-59.8h.2l.3.1z",
    fill: "url(#xcode-original-o)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-p",
    gradientUnits: "userSpaceOnUse",
    x1: 93.083,
    y1: 90.686,
    x2: 59.741,
    y2: 32.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a98ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bce7fa"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 33.3L93 90.1v.6L59.6 33l.2.1.2.1.2.1z",
    fill: "url(#xcode-original-p)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c98ea",
    d: "M91.5 86.9l-.2-.4s-.2 2-2.4 3.4c-2.1 1.3-4 .4-4 .4l.2.4s1.6 1.1 4-.4c2.4-1.4 2.4-3.4 2.4-3.4zM89 82.7l-.2-.4s-.5 2-2.6 3.2c-1.9 1.2-3.8.6-3.8.6l.2.4s1.7.7 3.9-.6c2.2-1.3 2.5-3.2 2.5-3.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6 78.5l-.2-.4s-.9 1.7-2.8 2.8c-1.7 1-3.6 1-3.6 1l.2.4s1.8 0 3.6-1c1.9-1.1 2.8-2.8 2.8-2.8z",
    fill: "#4ca4ed"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 74.3l-.2-.4s-1.3 1.7-3 2.6c-1.6.9-3.5 1.2-3.5 1.2l.2.4s1.9-.3 3.5-1.2c1.6-.9 3-2.6 3-2.6z",
    fill: "#4da7ee"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-q",
    gradientUnits: "userSpaceOnUse",
    x1: 67.981,
    y1: 61.226,
    x2: 74.457,
    y2: 57.487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9dff6"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3 57.3l.2.4s-1.7.8-3.4 1.7c-1.6.9-3 2.1-3 2.1l-.2-.4s1.5-1.2 3-2.1c1.7-.9 3.4-1.7 3.4-1.7z",
    fill: "url(#xcode-original-q)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-r",
    gradientUnits: "userSpaceOnUse",
    x1: 65.487,
    y1: 56.906,
    x2: 71.962,
    y2: 53.167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9dff6"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 53.1l.2.4s-1.9.6-3.5 1.6c-1.6.9-2.9 2.3-2.9 2.3l-.2-.4s1.3-1.4 2.9-2.3c1.6-1.1 3.5-1.6 3.5-1.6z",
    fill: "url(#xcode-original-r)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4 49.8c1.3-.4 2.3-.6 2.3-.6l-.2-.4s-.9.1-1.9.5c-.6.2-.7.7-.2.5z",
    fill: "#9dd4f7"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-s",
    gradientUnits: "userSpaceOnUse",
    x1: 57.93,
    y1: 43.819,
    x2: 64.364,
    y2: 40.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3e9fa"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6 40.5l.2.4s-1.9-.5-4.1.7c-1.9 1.2-2.3 3.1-2.3 3.1l-.2-.4s.2-1.7 2.3-3c2.2-1.4 4.1-.8 4.1-.8z",
    fill: "url(#xcode-original-s)"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-t",
    gradientUnits: "userSpaceOnUse",
    x1: 55.424,
    y1: 39.477,
    x2: 61.9,
    y2: 35.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3e9fa"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 36.2l.3.4s-2-.8-4.3.5C56 38.5 56 40.4 56 40.4l-.3-.4s-.2-1.7 2.2-3.2c2.5-1.5 4.3-.6 4.3-.6z",
    fill: "url(#xcode-original-t)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M55.5 71.3c8.7-15 18.7-32.4 18.7-32.4 1.3-2.2.5-5-1.7-6.3-2.2-1.3-5-.5-6.3 1.7 0 0-12.2 21.2-21.4 37h10.7zm-5.4 9.2C45.9 87.7 43 92.9 43 92.9c-1.3 2.2-4.1 3-6.3 1.7s-3-4.1-1.7-6.3c0 0 1.7-3.1 4.4-7.7 3.4-.1 9.6-.1 10.7-.1z"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-u",
    gradientUnits: "userSpaceOnUse",
    x1: 54.566,
    y1: 94.401,
    x2: 54.566,
    y2: 32.794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1285e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b5ef"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 71.3c8.8-15.2 19-32.9 19-32.9 1-1.7.4-4-1.3-5l-.1-.1c-1.7-1-4-.4-5 1.3 0 0-12 20.8-21.2 36.7h8.6zm-5.3 9.2c-4 7-6.9 12-6.9 12-1 1.7-3.2 2.3-5 1.3H37c-1.7-1-2.3-3.2-1.3-5 0 0 1.9-3.3 4.8-8.3h8.6z",
    fill: "url(#xcode-original-u)"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-v",
    gradientUnits: "userSpaceOnUse",
    x1: 40.681,
    y1: 94.131,
    x2: 74.064,
    y2: 36.311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3194e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71cff4"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 71.3L74 36.9v-.6s-11 19.1-20.2 35h.3zm-5.4 9.2l-7.6 13.2-.3.2-.3.1s3.4-5.9 7.8-13.5h.4z",
    fill: "url(#xcode-original-v)"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-w",
    gradientUnits: "userSpaceOnUse",
    x1: 39.063,
    y1: 94.482,
    x2: 73.557,
    y2: 34.736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aa6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2def8"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6 71.3l21-36.3-.1-.2-.1-.2S61.9 54.5 52.3 71.2l.3.1zm-5.3 9.2l-8 13.8h-.4s3.4-5.9 8-13.9c.2.1.4.1.4.1z",
    fill: "url(#xcode-original-w)"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-x",
    gradientUnits: "userSpaceOnUse",
    x1: 37.118,
    y1: 93.885,
    x2: 72.072,
    y2: 33.343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66abee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bee8fa"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 71.3c9.9-17.1 21.8-37.8 21.8-37.8l-.3-.2-22 38h.5zM45 80.6C40.6 88.3 37.3 94 37.3 94l-.3-.2s3.2-5.6 7.6-13.2c.2-.1.1-.1.4 0z",
    fill: "url(#xcode-original-x)"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-y",
    gradientUnits: "userSpaceOnUse",
    x1: 35.568,
    y1: 92.482,
    x2: 70.085,
    y2: 32.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bb6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1e3f9"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71.3c9.9-17.1 22.2-38.5 22.2-38.5h-.4S57.5 54.1 47.6 71.3h.4zm-5.8 9.2c-4 6.9-6.7 11.6-6.7 11.6l.1.2.1.2s2.9-5 7-12h-.5z",
    fill: "url(#xcode-original-y)"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-z",
    gradientUnits: "userSpaceOnUse",
    x1: 35.056,
    y1: 90.872,
    x2: 68.415,
    y2: 33.092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aa6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afe3f9"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 71.3l22-38.1-.2.1-.2.1-.1.1S55.8 54.6 46.2 71.3h.3zm-5.3 9.2c-3.5 6.1-6 10.4-6 10.4v-.8s2.2-3.8 5.6-9.7c.2.1.2.1.4.1z",
    fill: "url(#xcode-original-z)"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-A",
    gradientUnits: "userSpaceOnUse",
    x1: 66.362,
    y1: 35.689,
    x2: 72.838,
    y2: 39.428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89d4f5"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36.2l-.2.4s1.8-.9 4.2.4c2.2 1.2 2.3 3.3 2.3 3.3l.2-.4s.2-1.9-2.3-3.3-4.2-.4-4.2-.4z",
    fill: "url(#xcode-original-A)"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-B",
    gradientUnits: "userSpaceOnUse",
    x1: 63.856,
    y1: 40.03,
    x2: 70.332,
    y2: 43.768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89d4f5"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6 40.5l-.2.4s2-.6 4.1.6c2 1.1 2.4 3 2.4 3l.2-.4s-.2-1.8-2.4-3c-2.3-1.3-4.1-.6-4.1-.6z",
    fill: "url(#xcode-original-B)"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-C",
    gradientUnits: "userSpaceOnUse",
    x1: 61.273,
    y1: 44.505,
    x2: 67.748,
    y2: 48.243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89d4f5"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 44.7l-.2.4s1.8-.1 3.8 1.1c1.8 1 2.7 2.6 2.7 2.6l.2-.4s-.9-1.6-2.7-2.6c-1.9-1.1-3.8-1.1-3.8-1.1z",
    fill: "url(#xcode-original-C)"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-D",
    gradientUnits: "userSpaceOnUse",
    x1: 58.761,
    y1: 48.855,
    x2: 65.236,
    y2: 52.594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0dff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52bdf2"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 49l-.2.4s2 .3 3.7 1.3c1.6.9 2.8 2.4 2.8 2.4l.2-.4s-1.2-1.5-2.8-2.4c-1.7-1-3.7-1.3-3.7-1.3z",
    fill: "url(#xcode-original-D)"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-E",
    gradientUnits: "userSpaceOnUse",
    x1: 56.25,
    y1: 53.204,
    x2: 62.727,
    y2: 56.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4def8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eb5f0"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 53.2l-.2.4s1.9.5 3.6 1.5c1.6.9 2.9 2.2 2.9 2.2l.2-.4s-1.3-1.3-2.9-2.2c-1.6-.9-3.6-1.5-3.6-1.5z",
    fill: "url(#xcode-original-E)"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-F",
    gradientUnits: "userSpaceOnUse",
    x1: 53.74,
    y1: 57.553,
    x2: 60.215,
    y2: 61.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4def8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eb5f0"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 57.4l-.3.4s1.8.7 3.5 1.7c1.6.9 3 2 3 2l.2-.4s-1.4-1.1-3-2c-1.6-.9-3.4-1.7-3.4-1.7z",
    fill: "url(#xcode-original-F)"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-G",
    gradientUnits: "userSpaceOnUse",
    x1: 51.239,
    y1: 61.886,
    x2: 57.713,
    y2: 65.624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5ddf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46aeee"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1 62.1l.2-.4 6.5 3.7-.2.4-6.5-3.7z",
    fill: "url(#xcode-original-G)"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-H",
    gradientUnits: "userSpaceOnUse",
    x1: 48.735,
    y1: 66.22,
    x2: 55.211,
    y2: 69.959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46aaee"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 66.4l.2-.4s1.6 1.2 3.3 2.1c1.6.9 3.2 1.6 3.2 1.6l-.2.3s-1.7-.7-3.3-1.6c-1.7-.9-3.2-2-3.2-2z",
    fill: "url(#xcode-original-H)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 71.3c-.5-.4-.8-.7-.8-.7l.2-.4s.6.5 1.4 1.1h-.8z",
    fill: "#73b9f1"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-I",
    gradientUnits: "userSpaceOnUse",
    x1: 42.719,
    y1: 80.135,
    x2: 47.681,
    y2: 83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fc1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193ea"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 80.5c.4.3.8.6 1.3.9 1.8 1 3.6.9 3.6.9l-.2.4s-1.8.1-3.6-.9c-.7-.4-1.3-.9-1.7-1.3h.6z",
    fill: "url(#xcode-original-I)"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-J",
    gradientUnits: "userSpaceOnUse",
    x1: 38.634,
    y1: 83.717,
    x2: 45.11,
    y2: 87.456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fc1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193ea"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9 83.3l.2-.4s.5 2 2.7 3.2c2 1.1 3.8.5 3.8.5l-.2.4s-1.6.7-3.8-.5c-2.3-1.3-2.7-3.2-2.7-3.2z",
    fill: "url(#xcode-original-J)"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-K",
    gradientUnits: "userSpaceOnUse",
    x1: 36.124,
    y1: 88.063,
    x2: 42.599,
    y2: 91.802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fc1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193ea"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 87.6l.2-.4s.2 2.1 2.6 3.4c2.2 1.2 3.9.3 3.9.3l-.3.4s-1.5 1.1-3.9-.3c-2.5-1.4-2.5-3.4-2.5-3.4z",
    fill: "url(#xcode-original-K)"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-L",
    gradientUnits: "userSpaceOnUse",
    x1: 76.722,
    y1: 64.933,
    x2: 89.179,
    y2: 71.008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8 114.2l42.8-89.9-10.8-5.1-44.6 93.5s1.4.7 3.2 1.5h9.4z",
    fill: "url(#xcode-original-L)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "xcode-original-M",
    cx: 95.237,
    cy: 25.132,
    r: 16.181,
    fx: 79.585,
    fy: 25.974,
    gradientTransform: "matrix(-.4494 .8933 -1.5457 -.7777 176.886 -40.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1 13.8l20 9.5V52C107.2 48.7 61 26.7 61 26.7s3.2-6.7 6.2-12.9h26.9z",
    fill: "url(#xcode-original-M)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "xcode-original-N",
    cx: 51.211,
    cy: 114.953,
    r: 7.901,
    fx: 51.196,
    fy: 117.292,
    gradientTransform: "matrix(.8979 .4402 -.2506 .5111 34.032 33.662)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#0c0c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d4651"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 110.2c-.3.6-.8 1.3-.7 2.4.1 4.1 6.8 7.9 10.7 7.9 2.7 0 3.6-1.1 4.6-3.1s-13.5-9.6-14.6-7.2z",
    fill: "url(#xcode-original-N)"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-O",
    gradientUnits: "userSpaceOnUse",
    x1: 84.758,
    y1: 39.174,
    x2: 94.522,
    y2: 44.149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#344351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9697a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#8b8c95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#787a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#71747d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#777982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#87898f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8e8f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3d3b42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#606e84"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6 25.1s10.3 2.5 11.1 3.2-1.3 4.7-1.7 5.3c-3.3 4-13.6 26.1-13.6 26.1l-9.5-5.4s8.5-15.8 11.5-21.4c1.9-3.8 2.2-7.8 2.2-7.8z",
    fill: "url(#xcode-original-O)"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-P",
    gradientUnits: "userSpaceOnUse",
    x1: 117.884,
    y1: 29.257,
    x2: 106.863,
    y2: 14.364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#74747e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b0b0bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#74747e"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4 19.9c1.8 1.3 4.2 1 6.1.7 1.3-.2-.7 1.7-2.9 6.1s-2.1 4.7-2.4 4.4c-.3-.3-10.2-5.9-9.9-6.4.4-.5 2-11.4 2.8-11.1 2.9.7 3.4 4.2 6.3 6.3z",
    fill: "url(#xcode-original-P)"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-Q",
    gradientUnits: "userSpaceOnUse",
    x1: 98.542,
    y1: 30.424,
    x2: 114.815,
    y2: 28.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#606e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9899a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#475768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#262b33"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M99 32.2c.7-1.1 3.9-7.9 9-7.9 2.3 0 6.7 5.8 7.1 6.6.3.7-.7 3.5-1.2 2.2-.6-1.5-3.1-4.7-5.8-4.7s-6.4 3.1-7.3 4.2c-.9 1-2.5.7-1.8-.4z",
    fill: "url(#xcode-original-Q)"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-R",
    gradientUnits: "userSpaceOnUse",
    x1: 106.128,
    y1: 31.808,
    x2: 104.549,
    y2: 22.854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#101215",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#101215",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7b7d88"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8 31.8c.5-.8 2.8-4.3 3.9-5.4s3.9-4 6.3-4.4c2.4-.4 4.9 4.5 4.1 5.5-.6.7-1.6-.1-2.8-1.1-1.2-.9-2-2.7-5.8.2-1.3 1-2.6 1.8-5.6 6.1-.8 1.1-.6-.1-.1-.9z",
    fill: "url(#xcode-original-R)"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-S",
    gradientUnits: "userSpaceOnUse",
    x1: 58.131,
    y1: 81.721,
    x2: 73.237,
    y2: 89.154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#2c3952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#3d414e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#474a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#4e5057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#323945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143052"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 61c.4-.8.9-2-.2-2.9-1.2-.9-6.8-3.9-7.8-4.1-1-.2-1.8 0-2.2.7-.4.7-31.1 53.3-31.7 54.8-.6 1.5-.7 2.6.2 2.9.9.3 11.2 5.2 12.2 6.3 1 1.1 1.5-.1 1.9-.7 1.9-2.4 27.1-56.2 27.6-57z",
    fill: "url(#xcode-original-S)"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-T",
    gradientUnits: "userSpaceOnUse",
    x1: 81.508,
    y1: 31.679,
    x2: 93.19,
    y2: 6.047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#6d7078",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6d7078",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#35363a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#1d1f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#101215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#16171a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#292a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#4b4d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#63666b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#72757b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777a80"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 31.6c.5-.7 1.7-2.7 3.2-4.5 1-1.2 6.4-3.8 7.6-8 .7-2.3-.4-4.6-1.9-5.6-5.1-3.1-13.9-8-26.8-8-8.7 0-12.4 2.9-12.4 2.9h4.4l15.3 6 1.9 8s.2 2.7-.7 5.8c-.6 2.5-.8 4-1.7 6.5.7.3 2.3-.8 4.1-.3 1.6.4 2.6 2.6 3.7 1.3 1.9-2.5 2.5-3 3.3-4.1z",
    fill: "url(#xcode-original-T)"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-U",
    gradientUnits: "userSpaceOnUse",
    x1: 69.064,
    y1: 16.837,
    x2: 91.026,
    y2: 16.837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29292d"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 25.4C89.7 18 87.9 11 69.1 11.1c1.2-1.2 4.1-2.4 4.1-2.4l-4.1-.3s.6-.5 1.8-.6c11-.9 20.8 1.4 20.1 15.7-.1 2.3-.3 3.3-.5 1.9z",
    fill: "url(#xcode-original-U)"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-V",
    gradientUnits: "userSpaceOnUse",
    x1: 69.064,
    y1: 11.697,
    x2: 88.054,
    y2: 11.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#767880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0c0a0b"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1 11.1c1.3-.5 3.1-.8 6.5-.6 4.2.2 9.5 1.8 11.7 3.8 1.1 1 1 .2-.2-1.1-3.1-3.6-7.8-4.4-13.9-4.5-.7-.1-3 1.2-4.1 2.4z",
    fill: "url(#xcode-original-V)"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "xcode-original-W",
    gradientUnits: "userSpaceOnUse",
    x1: 116.332,
    y1: 34.756,
    x2: 123.707,
    y2: 21.982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#244668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#1a3249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#040506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#313236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#65656e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#868691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#92929e"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 20.6l5.5 2.8s-2.1 2.8-3.8 6c-1.8 3.4-3 7.1-3 7.1l-5.3-3.2s1.3-3.6 3.2-7.1c1.5-2.9 3.4-5.6 3.4-5.6z",
    fill: "url(#xcode-original-W)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M126.2 23.4c.4.2-.9 3.3-2.8 6.9-1.9 3.6-3.7 6.4-4 6.2-.4-.2.9-3.3 2.8-6.9 1.8-3.6 3.6-6.4 4-6.2z",
    fill: "#bfc0d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcodeOriginal);
export default __webpack_public_path__ + "static/media/xcode-original.b31073315b4f7b90614ba696ddc34957.svg";
export { ForwardRef as ReactComponent };